import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import { getBenefisCategoryAll } from "../../../BenefisCategory/_redux/benefisCategory/benefisCategoryCrud";
import {
  validateDataOrg as validateUpload,
  saveBenefisDataOrganisasi as saveBenefisData
} from "../../_redux/benefis/benefisCrud";
import { toast } from "react-toastify";
import BenefisImportTable from "./BenefisImportTable";
import BenefisInvalidTable from "./BenefisInvalidTable";
import Loading from "../../../../../_metronic/layout/components/loading/Loading";
import ModalEditBenefis from "./ModalEditBenefis";

export const BenefisImportOrganization = ({
  history,
  match: {
    params: { type, id }
  }
}) => {
  const [uploadData, setUploadData] = useState([]);
  const [successData, setSuccessData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [isValidation, setIsValidation] = useState(true);
  const [openEditBenefis, setOpenEditBenefis] = useState({
    show: false,
    initValues: {}
  });
  const [isStart, setIsStart] = useState(true);
  const [loading, setLoading] = useState({
    show: false,
    percentage: 0
  });

  const validateData = async () => {
    let dataSuccess = [];
    let dataError = [];

    setIsStart(false);

    try {
      if (successData.length === 0) {
        for (let i = 0; i < uploadData.length; i++) {
          await validateUpload(uploadData[i]).then(({ data }) => {
            if (Object.keys(data.errors).length > 0) {
              dataError.push({
                data: data.data,
                errors: data.errors
              });
            } else {
              dataSuccess.push(data.data);
            }
            let percentage = Math.round((i / uploadData.length) * 100);
            setLoading({ show: true, percentage: percentage });
          });
        }
      } else {
        for (let i = 0; i < successData.length; i++) {
          await validateUpload(successData[i]).then(({ data }) => {
            if (Object.keys(data.errors).length > 0) {
              dataError.push({
                data: data.data,
                errors: data.errors
              });
            } else {
              dataSuccess.push(data.data);
            }

            let percentage = Math.round((i / successData.length) * 100);
            setLoading({ show: true, percentage: percentage });
          });
        }
      }

      setErrorData(dataError);
      setSuccessData(dataSuccess);

      if (dataError.length === 0) {
        setIsValidation(false);
      }
    } catch (error) {
      toast.error("Terjadi Kesalahan Silakan Coba kembali");
    } finally {
      setLoading({ show: false, percentage: 0 });
    }
  };

  const getBenefisCategory = async () => {
    try {
      const res = await getBenefisCategoryAll();
      let options = [];
      res.data.data.map((item, index) => {
        options.push({ value: item.uuid, label: item.name });
      });

      return options;
    } catch (error) {
      toast.error("Terjadi Kesalahan");
    }
  };

  const downloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const benefis_category_xlsx = await getBenefisCategory();
    workbook.addWorksheet("import_data");
    workbook.addWorksheet("benefis_category_data");

    const category_data = workbook.getWorksheet("benefis_category_data");
    const worksheet = workbook.getWorksheet("import_data");
    worksheet.columns = [
      { header: "No", key: "no", width: 5 },
      { header: "Nama Organisasi", key: "name", width: 20 },
      { header: "Nama PIC", key: "pic_name", width: 20 },
      { header: "Telepon PIC", key: "pic_hp", width: 20 },
      { header: "Email PIC", key: "pic_email", width: 30 },
      { header: "No KTP / No Perusahaan", key: "nik", width: 30 },
      { header: "Jumlah Anggota", key: "qty", width: 30 },
      {
        header: "Kategori Penerima Manfaat",
        key: "benefis_category",
        width: 45
      },
      { header: "Provinsi", key: "province", width: 20 },
      { header: "Kota", key: "city", width: 20 },
      { header: "Kecamatan", key: "district", width: 20 },
      { header: "Kode Pos", key: "postal_code", width: 20 },
      { header: "Status Hidup", key: "is_alive", width: 20 },
      { header: "Status Aktif", key: "is_active", width: 20 }
    ];

    benefis_category_xlsx.map(item => {
      category_data.addRow([`${item.label}  -  ${item.value}`]);
    });

    worksheet.dataValidations.add("H2:H1001", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: [
        `=benefis_category_data!$A$1:$A$${benefis_category_xlsx.length}`
      ],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Kategori Penerima Manfaat"
    });

    worksheet.dataValidations.add("M2:M1001", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: ['"Hidup,Meninggal"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Status Hidup"
    });

    worksheet.dataValidations.add("N2:N1001", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: ['"Aktif,Tidak Aktif"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Status Aktif"
    });

    workbook.xlsx.writeBuffer().then(function(buffer) {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `template_import_PM_Kelompok.xlsx`
      );
    });
  };

  const readXlsxFile = e => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = evt => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      if (
        data[0][0] !== "No" ||
        data[0][1] !== "Nama Organisasi" ||
        data[0][2] !== "Nama PIC" ||
        data[0][3] !== "Telepon PIC" ||
        data[0][4] !== "Email PIC" ||
        data[0][5] !== "No KTP / No Perusahaan" ||
        data[0][6] !== "Jumlah Anggota" ||
        data[0][7] !== "Kategori Penerima Manfaat" ||
        data[0][8] !== "Provinsi" ||
        data[0][9] !== "Kota" ||
        data[0][10] !== "Kecamatan" ||
        data[0][11] !== "Kode Pos" ||
        data[0][12] !== "Status Hidup" ||
        data[0][13] !== "Status Aktif"
      ) {
        toast.error("Template Tidak Sesuai");
        return;
      }

      let objData = {};
      let arrData = [];

      data.map((item, index) => {
        if (index > 0) {
          objData = {
            name: item[1],
            pic_name: item[2],
            pic_hp: item[3] ? item[3].toString() : "",
            pic_email: item[4],
            nik: item[5],
            qty: item[6],
            benefis_category_name: item[7]
              ? item[7].split(" - ")[0].trim()
              : "",
            benefis_category_uuid: item[7]
              ? item[7].split(" - ")[1].trim()
              : "",
            benefis_category: item[7],
            province: item[8],
            city: item[9],
            district: item[10],
            postal_code: item[11],
            is_alive: item[12],
            is_active: item[13]
          };
          arrData.push(objData);
        }
      });
      setUploadData(arrData);
    };

    reader.readAsBinaryString(file);
  };

  const hideEditBenefis = () => {
    setOpenEditBenefis({
      ...openEditBenefis,
      show: false,
      initValues: {}
    });
  };

  const saveEditedData = value => {
    let newErrorData = errorData.filter(item => item.data.key !== value.key);
    let newSuccessData = [...successData, value];
    setErrorData(newErrorData);
    setSuccessData(newSuccessData);
  };

  const saveFinishedData = () => {
    let arrPromise = [];
    let percentage = 0;
    successData.map(item => {
      arrPromise.push(saveBenefisData(item));
    });

    setLoading({ ...loading, show: true });

    Promise.all(arrPromise)
      .then(res => {
        percentage = (res.length / successData.length) * 100;
        setLoading({ ...loading, percentage: percentage });
        toast.success("Data Berhasil Disimpan");
        setUploadData([]);
        setErrorData([]);
        setSuccessData([]);
        history.goBack();
      })
      .catch(err => {
        toast.error("Data Gagal Disimpan");
      })
      .finally(() => {
        setLoading({ ...loading, show: false });
      });
  };

  return (
    <>
      <Loading {...loading} />
      <ModalEditBenefis
        {...openEditBenefis}
        onHide={() => hideEditBenefis()}
        onSubmit={value => {
          saveEditedData(value);
          hideEditBenefis();
        }}
      />
      <Card>
        <CardHeader title="Import Penerima Manfaat Kelompok">
          <CardHeaderToolbar>
            {RoleChecker("Create", "benefis") && (
              <button
                type="button"
                className="btn btn-outline-primary ml-4"
                onClick={() => {
                  downloadTemplate();
                }}
              >
                Download Template
              </button>
            )}
            <button
              className="btn btn-secondary ml-4"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-lg-2">
              <label>Import Data: </label>
            </div>
            <div className="col-lg-10">
              <input
                type="file"
                accept=".xlsx"
                onChange={e => {
                  readXlsxFile(e);
                }}
              />
            </div>
          </div>
        </CardBody>
      </Card>

      {errorData.length !== 0 && (
        <Card>
          <CardHeader title="Data tidak valid" />
          <CardBody>
            <BenefisInvalidTable
              errorRows={errorData}
              setOpenEditBenefis={setOpenEditBenefis}
            />
          </CardBody>
        </Card>
      )}

      <Card>
        <CardHeader title="Daftar Import">
          <CardHeaderToolbar></CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BenefisImportTable
            dataTable={isStart ? uploadData : successData}
            saveData={saveFinishedData}
            isValidation={isValidation}
            validateData={validateData}
            errorRows={errorData}
          />
        </CardBody>
      </Card>
    </>
  );
};
